import React from 'react'
import { Button } from 'antd';
import Config from "../../../config/Config";
import { formatSalaryRange, getSalaryDisplay, tagRedirect } from '../../com/utils';
import NoData from '../../com/NoData';
import './table.scss';
let path = Config.getBasePath();
class table extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }
  async componentDidMount() {

  }



  check = (data) => {
    this.props.history.push({ pathname: '/home/messageCenter/mes_info',data:{type:'feedback',data} })
  }



  render() {
    const { options, operate, data } = this.props;

    return <div component-data="personalCenter">
      <div className='table_box'>
        {
          data && data.length > 0 ?
            data.map((item) => {
              let SAL = formatSalaryRange(item?.SALFROM, item?.SALTO);
              let SALFROM = SAL[0];
              let SALTO = SAL[1];
              return <div className='job_box_item'>
                <div className='sf-between job_head'>
                  <div className='job_item_head '>
                    <div className='job_info_detail'>
                      <div className='job_title' onClick={() => tagRedirect({ job_key: item?.job_id }, 'JobDetails')}>{item?.JOBNAME}</div>
                      <div className='job_salary'>
                        {getSalaryDisplay(SALFROM, SALTO)}
                        {item.SALPAY == "11" ? "元/小时" : ""}
                        {item.SALPAY == "12" ? "元/天" : ""}
                        {item.SALPAY == "13" ? "元/周" : ""}
                      </div>
                    </div>
                  </div>
                  {
                    // options && options.tips ?
                      <div className='job_tips'>
                        {item?.arranging_time ?item.arranging_time:' '}
                        {item?.CONFIRM === '2' ? '已查看' : null}
                        {item?.CONFIRM === '0' || item?.CONFIRM === '1' ? <div >已向您发起面试邀请【<a onClick={()=>this.check(item)}>查看详情</a>】</div> : null}
                        {item?.CONFIRM === '6' ? '感谢投递，HR认为你与该职位不太匹配' : null}
                      </div>
                      // : null
                  }

                </div>

                <div className='sf-page-tool-between ' style={{padding:'10px 16px 16px 16px'}}>
                  <div>
                    <div className='job_tag_box'>
                      {item?.DISTRICT_CN ? <div className='job_tag'>{item.DISTRICT_CN}</div> : ""}
                      {item.REQWE_CN ? <div className='job_tag'>{item.REQWE_CN}</div> : ""}
                      {item.REQEDU_CN ? <div className='job_tag'>{item.REQEDU_CN}</div> : ""}
                      {!item.REQAGEFROM && !item.REQAGETO ? <div className='job_tag'>{'不限年龄'}</div> : ""}
                      {item.REQAGEFROM && !item.REQAGETO ? <div className='job_tag'>{item.REQAGEFROM + '岁以上'}</div> : ""}
                      {!item.REQAGEFROM && item.REQAGETO ? <div className='job_tag'>{item.REQAGETO + '岁以内'}</div> : ""}
                      {item.REQAGEFROM && item.REQAGETO ? <div className='job_tag'>{item.REQAGEFROM + ' - ' + item.REQAGETO + '岁'}</div> : ""}
                    </div>
                    <div className='ent_box'>
                      <img className='ent_logo' src={require("../../../img/pinzhunzhun/enterprise/ent-logo.png")} />
                      <div className='ent_title' onClick={() => tagRedirect({ enterprise_key: item?.enterprise_id }, 'enterprise/detail')}>{item?.ENTNAME}</div>
                      <div className='ent_detail'>
                        <div className='ellipsis-text' title={item?.INDTYPE_CN}>{item.INDTYPE_CN ? item.INDTYPE_CN : null}</div>
                        {item.SCALE_CN ? <div className='line'>|</div> : null}
                        {item.SCALE_CN ? item.SCALE_CN : null}
                        {item.ENTTYPE_CN ? <div className='line'>|</div> : null}
                        {item.ENTTYPE_CN ? item.ENTTYPE_CN : null}
                      </div>
                    </div>
                  </div>

                  {
                    options?.operate ?
                      <div className='job-detail-op'>
                        {
                          operate(item)
                        }
                      </div>
                      : null
                  }
                </div>
              </div>
            })
            :
            <NoData width={'400px'} height={'400px'} />
        }
      </div>
    </div >
  }
}

export default table;